(() => {
  const BEHAVIOR_NAME = 'bob_mobile_sticky_atc_v1_winner';
  const EARLY_STICKY = 'early_sticky';
  const MOBILE_QUERY = '(max-width: 767px)';

  // The rule now applies at every width: the sticky bar shows only while the
  // page's own Add to cart button is off screen. Desktop used Taiga's original
  // logic, which could leave the bar up over a visible button.
  function viewport() {
    return window.matchMedia && window.matchMedia(MOBILE_QUERY).matches ? 'mobile' : 'desktop';
  }

  const buyBar = document.querySelector('.product-buy-bar');
  const mainForm = document.querySelector('.product-block__buy_buttons form[data-type="add-to-cart-form"]') || document.querySelector('form[id^="product-form-"]:not([id$="-product-buy-bar"])');
  const stickyForm = buyBar ? buyBar.querySelector('form[data-type="add-to-cart-form"]') : null;
  const mainAtc = mainForm ? mainForm.querySelector('[type="submit"][name="add"], [type="submit"]') : document.querySelector('.product-block__buy_buttons [name="add"]');
  const stickyAtc = stickyForm ? stickyForm.querySelector('[type="submit"][name="add"], [type="submit"]') : null;

  if (!buyBar || !mainAtc) return;

  const variant = EARLY_STICKY;
  document.documentElement.setAttribute('data-bob-sticky-atc-test', variant);
  document.documentElement.setAttribute('data-bob-sticky-atc-behavior', variant);

  function sendDiagnosticEvent(eventName, eventParams = {}) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function() {
      window.dataLayer.push(arguments);
    };

    window.gtag('event', eventName, {
      test_name: BEHAVIOR_NAME,
      sticky_atc_test: variant,
      sticky_atc_behavior: variant,
      test_variant: variant,
      viewport: viewport(),
      page_path: window.location.pathname,
      ...eventParams
    });
  }

  function isMainAtcInView() {
    const rect = mainAtc.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

    return rect.top < viewportHeight && rect.bottom > 0 && rect.left < viewportWidth && rect.right > 0;
  }

  let stickyImpressionSent = false;

  function trackStickyImpressionIfShown() {
    if (stickyImpressionSent || !buyBar.classList.contains('show')) return;
    stickyImpressionSent = true;
    sendDiagnosticEvent('bob_sticky_atc_impression', {
      sticky_atc_source: 'sticky_atc'
    });
  }

  const impressionObserver = new MutationObserver(trackStickyImpressionIfShown);
  impressionObserver.observe(buyBar, { attributes: true, attributeFilter: ['class'] });

  if (stickyAtc) {
    stickyAtc.addEventListener('click', () => {
      sendDiagnosticEvent('bob_sticky_atc_click', {
        sticky_atc_source: 'sticky_atc'
      });
    }, true);
  }

  sendDiagnosticEvent('bob_sticky_atc_winner_view');
  trackStickyImpressionIfShown();

  let isUpdatingVisibility = false;
  let visibilityFrameQueued = false;

  function setEarlyStickyVisibility() {
    if (isUpdatingVisibility) return;

    isUpdatingVisibility = true;
    const shouldShow = !isMainAtcInView();
    buyBar.classList.toggle('show', shouldShow);

    if (shouldShow) trackStickyImpressionIfShown();

    window.requestAnimationFrame(() => {
      isUpdatingVisibility = false;
    });
  }

  function queueVisibilityCheck() {
    if (visibilityFrameQueued) return;

    visibilityFrameQueued = true;
    window.requestAnimationFrame(() => {
      visibilityFrameQueued = false;
      setEarlyStickyVisibility();
    });
  }

  const mainAtcObserver = new IntersectionObserver(queueVisibilityCheck, { threshold: 0.01 });
  mainAtcObserver.observe(mainAtc);

  const visibilityMutationObserver = new MutationObserver(() => {
    if (!isUpdatingVisibility) queueVisibilityCheck();
  });
  visibilityMutationObserver.observe(buyBar, { attributes: true, attributeFilter: ['class'] });

  window.addEventListener('scroll', queueVisibilityCheck, { passive: true });
  window.addEventListener('resize', queueVisibilityCheck, { passive: true });
  window.addEventListener('orientationchange', queueVisibilityCheck, { passive: true });

  setEarlyStickyVisibility();
})();